window.portalModule.controller 'EnrollmentTaskController',
['enrollmentGuid', '$log', 'RegistrationService', 'UtilityService', '$scope', '$state',
(enrollmentGuid, $log, RegistrationService, UtilityService, $scope, $state) ->
    $log = $log.getInstance('EnrollmentTaskController')
    $log.log('enrollment task controller loaded.')

    $scope.showRetiredMessage = false
    $scope.practiceName = null
    $scope.retiredVariant = null

    RegistrationService.getEnrollment(enrollmentGuid).then((enrollment) ->
        if enrollment
            practiceHasRetired = UtilityService.isRetiredWithoutFmh(
                isRetired: enrollment.isPatientFusionRetired
                isFmhOnboarded: enrollment.isFmhOnboardingCompleted
            )
            enrollmentHasExpired = moment.utc(enrollment.expiresAt).isBefore()
            enrollmentIsComplete = enrollment.status?.toLowerCase() == 'completed'
            enrollmentIsPendingForExistingUser = (
                enrollment.status?.toLowerCase() == 'pending' and enrollment.phrUserProfileGuid
            )
            if(practiceHasRetired)
                $log.log('The practice has retired Patient Fusion; leaving the invite untouched')
                $scope.practiceName = enrollment.practiceName
                $scope.retiredVariant = UtilityService.retiredInviteVariant(
                    enrollment.relationshipToPatient
                )
                $scope.showRetiredMessage = true
            else if(enrollmentHasExpired or enrollmentIsComplete or enrollmentIsPendingForExistingUser)
                if(enrollmentHasExpired)
                    $log.log('The enrollment request has expired')
                if(enrollmentIsComplete)
                    $log.log('The enrollment request has already been completed')
                if(enrollmentIsPendingForExistingUser)
                    $log.log('The enrollment is pending for a user profile which already exists')
            else
                RegistrationService.updateEnrollment(enrollmentGuid)
    ).finally ->
        $state.go('root') unless $scope.showRetiredMessage
]
